if (!customElements.get('product-addons')) {
  customElements.define(
    'product-addons',
    class ProductAddons extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
      }

      connectedCallback() {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.loadAddons();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
      }

      loadAddons() {
        const baseUrl = this.dataset.url;
        const productId = this.dataset.productId;
        const sectionId = this.dataset.sectionId;

        if (!baseUrl || !productId || !sectionId) return;

        const url = `${baseUrl}&product_id=${productId}&section_id=${sectionId}`;

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;

            // 某些 section 响应里可能包含多个同 block 的副本，优先使用卡片数最多的那个，
            // 避免误拿到不完整的节点副本。
            const blockId = this.dataset.blockId;
            let candidates = [];
            if (blockId) {
              candidates = Array.from(html.querySelectorAll(`product-addons[data-block-id="${blockId}"]`));
            }
            if (!candidates.length) {
              candidates = Array.from(html.querySelectorAll('product-addons'));
            }
            const node = candidates.sort((left, right) => {
              const rightCount = right.querySelectorAll('.product-addons__item').length;
              const leftCount = left.querySelectorAll('.product-addons__item').length;

              if (rightCount !== leftCount) return rightCount - leftCount;
              return right.innerHTML.length - left.innerHTML.length;
            })[0];

            if (node && node.innerHTML.trim().length) {
              this.innerHTML = node.innerHTML;
              this.classList.add('product-addons--loaded');
            } else {
              this.remove();
            }
          })
          .catch((error) => {
            console.error('[product-addons] load failed:', error);
          });
      }
    }
  );
}
